import type { Task } from "@/api/tasks";

export function compareTaskBoardOrder(a: Task, b: Task): number {
  const at = a.ticket_number ?? Number.POSITIVE_INFINITY;
  const bt = b.ticket_number ?? Number.POSITIVE_INFINITY;
  if (at !== bt) return at - bt;

  const ac = new Date(a.created_at).getTime();
  const bc = new Date(b.created_at).getTime();
  if (ac !== bc) return ac - bc;

  return a.id.localeCompare(b.id);
}

export function sortTaskBoardOrder<T extends Task>(tasks: T[]): T[] {
  return [...tasks].sort(compareTaskBoardOrder);
}
